import { apiClient, ApiError } from './client';
import { createContextLogger } from '../utils/logger';

const logger = createContextLogger('ApiSetup');

// Type for error tracking data
interface ErrorTrackingData {
  message: string;
  status?: number;
  code?: string;
  details?: unknown;
  timestamp: string;
}

// Setup functions for common configurations
export const setupAuth = (token: string) => {
  apiClient.setAuthToken(token);
};

export const clearAuth = () => {
  apiClient.clearAuthToken();
};

export const setupRequestLogging = () => {
  apiClient.addRequestInterceptor((config: RequestInit, url: string) => {
    logger.debug('🚀 API Request:', {
      method: config.method,
      url,
      headers: config.headers,
      timestamp: new Date().toISOString(),
    });
    return config;
  });

  apiClient.addResponseInterceptor((response: Response, url: string) => {
    logger.debug('📥 API Response:', {
      status: response.status,
      statusText: response.statusText,
      url,
      timestamp: new Date().toISOString(),
    });
    return response;
  });
};

export const setupErrorTracking = (trackingFn: (error: ErrorTrackingData) => void) => {
  apiClient.addErrorHandler((error: Error | ApiError) => {
    const trackingData: ErrorTrackingData = {
      message: error.message,
      status: error instanceof ApiError ? error.status : undefined,
      code: error instanceof ApiError ? error.code : undefined,
      details: error instanceof ApiError ? error.details : undefined,
      timestamp: new Date().toISOString(),
    };
    trackingFn(trackingData);
  });
}; 